// tslint:disable-next-line
///<reference path="../../typings/index.d.ts"/>

export {AbstractInitializeBrowserAction} from "./extendible/actions/AbstractInitializeBrowserAction";
export {AbstractRouteAction} from "./extendible/actions/AbstractRouteAction";

export {AbstractRootRouteState} from "./extendible/state/AbstractRootRouteState";
export {AbstractRouteState} from "./extendible/state/AbstractRouteState";
export {PageMetadataState} from "./extendible/state/PageMetadataState";

export {FireRouteUpdateAction} from "./reusable/FireRouteUpdateAction";
export {NotFoundError} from "./reusable/NotFoundError";

export {QueryParam} from "./decorators/QueryParam";
export {SegmentParam} from "./decorators/SegmentParam";
export {Segment} from "./decorators/Segment";

export {RouteBuilder} from "./helpers/RouteBuilder";
export {IRouteBuilderInstance} from "./base/IRouteBuilderInstance";

export {SkeletosWebRouterConstants} from "./helpers/SkeletosWebRouterConstants";

// internal stuff, useful to frameworks built on top of skeletos-react-web-router
export {IRouteStateClassInfo} from "./base/IRouteStateClassInfo";
export {InternalRouteBuilder} from "./base/InternalRouteBuilder";


// WEBPACK FOOTER //
// ./src/web-router/index.ts